import React, { useEffect, useState } from "react";
import { backend_url } from "../App";
import Hero from '../Components/Hero/Hero'
import Videos from '../Components/Videos/Videos'
import About from "../Components/About/About"
import Category from '../Components/Category/Category'
import Card from '../Components/Card/Card'
import NewArrival from '../Components/Newarrival/Newarrival'
import Featured from '../Components/Featured/Featured'
// import Accessories from '../Components/Accessories/Accessories'
import Design from '../Components/Design/Design'
import Customer from '../Components/Customer/Customer'
import Variety from '../Components/Variety/Variety'
import BestSeller from '../Components/BestSeller/BestSeller'
import RetroCollection from '../Components/RertoCollection/Retro'
import ProductSearchCard from '../Components/ProductSearchCard/ProductSearchCard'


const Shop = () => {
  const [searchResults, setSearchResults] = useState([]);

  const [popular, setPopular] = useState([]);
  const [newCollection, setNewCollection] = useState([]);

  useEffect(() => {
    const fetchInfo = async () => {
      const res1 = await fetch(`${backend_url}/popularinwomen`);
      const data1 = await res1.json();
      setPopular(data1);

      const res2 = await fetch(`${backend_url}/newcollections`);
      const data2 = await res2.json();
      setNewCollection(data2);
    };

    fetchInfo();
  }, []);

  return (
    // <div >
    //   {searchResults.length > 0 ? (
    //     <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
    //       {searchResults.map((product) => (
    //         <ProductSearchCard key={product.id} product={product} />
    //       ))}
    //     </div>
    //   ) : (
    //     <>
    //       {/* Render homepage only if no search results */}
    //       <Hero />
    //        <About />
    //        <Videos />
    //        <Category />
    //        <Card />
    //        <NewArrival />
    //        <Design />
    //        <RetroCollection />
    //        <Variety />
    //        <BestSeller />
    //        <Featured />
    //        <Customer />
    //       {/* Add more homepage components here */}
    //     </>
    //   )}
    // </div>
    <div className="min-h-screen w-full overflow-x-hidden">
  {searchResults.length > 0 ? (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      {searchResults.map((product) => (
        <ProductSearchCard key={product.id} product={product} />
      ))}
    </div>
  ) : (
    <>
      <Hero />
      <About />
      <Videos />
      <Category />
      <Card />
      <NewArrival />
      <Design />
      <RetroCollection />
      <Variety />
      <BestSeller />
      <Featured />
      <Customer />
    </>
  )}
</div>

  );
};

export default Shop;
